import React, {Component} from 'react';
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography, CircularProgress} from '@mui/material';
import Api from '../../api';
import {EDIT_DLT_URL} from '../../lib/constant';

// Clear DLT ID: DELETE removes the org's PE ID (its India sends stop until a
// new one is set) and puts a self-signup org back at the start of its
// first-run. Double confirm: the warning, then typing the DLT ID enables Clear.
export default class ClearDLT extends Component {
  constructor(props){
    super(props);
    this.state={
      typed: '',
      error: '',
      saving: false
    }
  }
  handleClearDLT = async () =>{
    if(this.state.typed.trim() !== this.props.dltPrincipalEntityId) return;
    this.setState({error: '', saving: true});
    try {
      const url = EDIT_DLT_URL.replace('{instId}', this.props.tenantId);
      await Api.delete(url);
      this.props.onSuccess();
    } catch (err) {
      const msg = err?.response?.data?.message || err?.response?.data?.error || err?.message || 'Failed to clear DLT ID';
      this.setState({error: msg, saving: false});
    }
  }
  render(){
    const {typed, error, saving} = this.state;
    const {dltPrincipalEntityId, tenantName} = this.props;
    const confirmed = typed.trim() === dltPrincipalEntityId;
    return(
      <Dialog
        open={true}
        onClose={saving ? undefined : this.props.onClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Clear DLT ID</DialogTitle>
        <DialogContent style={{paddingTop: 8}}>
          <Alert severity="warning" style={{marginBottom: 16}}>
            This removes DLT ID <b>{dltPrincipalEntityId}</b>{tenantName ? <> from <b>{tenantName}</b></> : null}.
            The org's India SMS are blocked until a new DLT ID is set, and a self-signup org
            sees the first-run setup again on its next login.
          </Alert>
          <Typography style={{fontSize: 14, marginBottom: 8}}>
            Type the DLT ID to confirm:
          </Typography>
          <TextField
            label="DLT ID"
            value={typed}
            fullWidth
            autoFocus
            variant="standard"
            error={!!error}
            helperText={error}
            disabled={saving}
            inputProps={{style: {fontSize: 16, letterSpacing: 0.5}}}
            onChange={(e)=>{this.setState({typed : e.target.value, error: ''})}} />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} disabled={saving}>Cancel</Button>
          <Button onClick={this.handleClearDLT} variant='contained' color='error' disabled={!confirmed || saving}>
            {saving ? <CircularProgress size={20} /> : 'Clear DLT ID'}
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}
